import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import history from './history';

// App Routes
import Routes from './Routes';

// Vendor dependencies
import './Vendor.js';
import './styles/estilos_general.css';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css';

const App = () => {
  useEffect(() => {
    // document.onpaste = function() {
    //   return false;
    // };
    // document.oncontextmenu = function() {
    //   return false;
    // };
  }, []);
  return (
    <Router history={history}>
      <Routes />
    </Router>
  );
};

export default App;
